var moduleMap = {
	"./dashboard-lite": () => {
		return Promise.all(/* __federation_expose_dashboard_lite */[__webpack_require__.e(514), __webpack_require__.e(517), __webpack_require__.e(789)]).then(() => (() => ((__webpack_require__(38876)))));
	},
	"./channel-multiplexer": () => {
		return Promise.all(/* __federation_expose_channel_multiplexer */[__webpack_require__.e(517), __webpack_require__.e(373)]).then(() => (() => ((__webpack_require__(24133)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});